import { render } from "./statusList.vue?vue&type=template&id=6a5b2968&scoped=true"
import script from "./statusList.vue?vue&type=script&lang=js"
export * from "./statusList.vue?vue&type=script&lang=js"

import "./statusList.vue?vue&type=style&index=0&id=6a5b2968&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6a5b2968"

export default script